import { useState } from 'react';
import AvatarChip from './avatar-chip';
import { emailRegex } from '../utils/regular-expressions';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';
interface ExternalUsersInputProps {
  value: string[];
  onAdd: (email: string) => void;
  onRemove: (email: string) => void;
  label?: string;
  placeholder?: string;
  buttonText?: string;
  sx?: SxProps<Theme>;
}

export default function ExternalUsersInput({
  value,
  onAdd,
  onRemove,
  label = 'Include External Users',
  placeholder = 'External Email',
  buttonText = 'Add',
  sx,
}: ExternalUsersInputProps) {
  const [inputValue, setInputValue] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleAddEmail = () => {
    if (!emailRegex.test(inputValue)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    if (value.includes(inputValue)) {
      setEmailError('This email is already added.');
      return;
    }

    onAdd(inputValue);
    setInputValue('');
    setEmailError('');
  };

  return (
    <Stack gap={1} sx={{ mt: 2, ...sx }}>
      {label && <Typography>{label}</Typography>}
      <Stack flexDirection="row" gap={1}>
        <Box sx={{ width: 400 }}>
          <TextField
            autoComplete="off"
            fullWidth
            label={placeholder}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
              if (emailError) setEmailError('');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddEmail();
              }
            }}
            error={!!emailError}
            helperText={emailError || ' '}
          />
        </Box>

        <Button
          sx={{ height: 40 }}
          variant="contained"
          size="small"
          onClick={handleAddEmail}
          disabled={inputValue.length === 0}
        >
          {buttonText}
        </Button>
      </Stack>
      <Stack
        flexDirection="row"
        gap={1}
        flexWrap="wrap"
        sx={{ mt: 1, mb: 2 }}
        maxWidth={450}
      >
        {value && value.length > 0
          ? value.map((user) => {
              return (
                <AvatarChip
                  key={user}
                  label={user}
                  type={'User'}
                  email={user}
                  onDelete={() => onRemove(user)}
                />
              );
            })
          : null}
      </Stack>
    </Stack>
  );
}
